"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
/* eslint-disable no-nested-ternary */
const malty_atoms_button_1 = require("@carlsberggroup/malty.atoms.button");
const malty_atoms_icon_1 = require("@carlsberggroup/malty.atoms.icon");
const malty_atoms_text_1 = require("@carlsberggroup/malty.atoms.text");
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = __importStar(require("react"));
const Chip_styled_1 = require("./Chip.styled");
const Chip_types_1 = require("./Chip.types");
function Chip({ label, size = Chip_types_1.ChipSize.Medium, selected = false, onChange = () => null, icon, showAction = false, dataTestId, disabled = false, readOnly = false }) {
    const theme = malty_theme_malty_theme_provider_1.globalTheme;
    const [chipSize, setChipSize] = (0, react_1.useState)(theme.sizes.l.value);
    const [fontSize, setFontSize] = (0, react_1.useState)(malty_atoms_text_1.TextStyle.MediumSmallBold);
    const [buttonSize, setButtonSize] = (0, react_1.useState)(malty_atoms_button_1.ButtonSize.Medium);
    const handleClick = () => {
        onChange(!selected);
    };
    (0, react_1.useEffect)(() => {
        switch (size) {
            case Chip_types_1.ChipSize.XSmall: {
                setChipSize(theme.sizes.m.value);
                setFontSize(malty_atoms_text_1.TextStyle.SmallBold);
                setButtonSize(malty_atoms_button_1.ButtonSize.XSmall);
                break;
            }
            case Chip_types_1.ChipSize.Small: {
                setChipSize(theme.sizes.l.value);
                setFontSize(malty_atoms_text_1.TextStyle.MediumSmallBold);
                setButtonSize(malty_atoms_button_1.ButtonSize.Small);
                break;
            }
            default: {
                setChipSize(theme.sizes.xl.value);
                setFontSize(malty_atoms_text_1.TextStyle.MediumSmallBold);
                setButtonSize(malty_atoms_button_1.ButtonSize.Medium);
                break;
            }
        }
    }, [size, theme]);
    return (react_1.default.createElement(Chip_styled_1.StyledChip, { hasButton: showAction, disabled: disabled, readOnly: readOnly, "data-testid": dataTestId, onClick: handleClick, selected: selected, height: chipSize, size: size, theme: theme },
        !showAction && icon && (react_1.default.createElement(Chip_styled_1.StyledIcon, { "data-testid": `${dataTestId}-icon`, theme: theme },
            react_1.default.createElement(malty_atoms_icon_1.Icon, { name: icon, color: readOnly && selected
                    ? malty_atoms_icon_1.IconColor.White
                    : readOnly && !selected
                        ? malty_atoms_icon_1.IconColor.Support80
                        : disabled
                            ? malty_atoms_icon_1.IconColor.DisableLight
                            : selected
                                ? malty_atoms_icon_1.IconColor.White
                                : malty_atoms_icon_1.IconColor.DigitalBlack, size: size === Chip_types_1.ChipSize.XSmall ? malty_atoms_icon_1.IconSize.Small : malty_atoms_icon_1.IconSize.MediumSmall }))),
        react_1.default.createElement(Chip_styled_1.StyledTextContainer, { hasButton: showAction, hasIcon: !!icon, size: size, "data-testid": `${dataTestId}-label`, theme: theme },
            react_1.default.createElement(malty_atoms_text_1.Text, { textStyle: fontSize, color: (readOnly && selected
                    ? malty_atoms_text_1.TextColor.White
                    : readOnly && !selected
                        ? malty_atoms_text_1.TextColor.Support80
                        : disabled
                            ? malty_atoms_icon_1.IconColor.DisableLight
                            : selected
                                ? malty_atoms_icon_1.IconColor.White
                                : malty_atoms_icon_1.IconColor.DigitalBlack) }, label)),
        showAction && (react_1.default.createElement(malty_atoms_button_1.Button, { disabled: disabled || readOnly, negative: selected && !disabled, dataTestId: `${dataTestId}-button`, size: buttonSize, style: malty_atoms_button_1.ButtonStyle.Transparent, icon: malty_atoms_icon_1.IconName.Plus }))));
}
exports.Chip = Chip;
//# sourceMappingURL=Chip.js.map